// tslint:disable:max-line-length

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import type * as rest from "../rest";
import type * as t from "./reservations.generated.types";

function enc(s: any) { return encodeURIComponent("" + s); }

export interface IReservations {
    /** Gets week view */
    getWeek(req: t.IGetWeekReq): Promise<t.IGetWeekRes>;

    /** Insert new reservation */
    insertReservation(req: t.IInsertReservationReq): Promise<t.IInsertReservationRes>;

    /** Update reservation */
    updateReservation(req: t.IUpdateReservationReq): Promise<t.IUpdateReservationRes>;

    /** Delete reservation */
    deleteReservation(req: t.IDeleteReservationReq): Promise<t.IDeleteReservationRes>;

    /** Gets my reservations */
    getMyReservations(req: t.IGetMyReservationsReq): Promise<t.IGetMyReservationsRes>;

    /** Gets single reservation */
    getSingleReservation(req: t.IGetSingleReservationReq): Promise<t.IGetSingleReservationRes>;

    /** Gets my invoices */
    getMyInvoices(req: t.IGetMyInvoicesReq): Promise<t.IGetMyInvoicesRes>;

    /** Download invoice */
    downloadInvoice(req: t.IDownloadInvoiceReq): Promise<t.IDownloadInvoiceRes>;

}

export class Reservations implements IReservations {

    private client: rest.IApiClient;

    constructor(client: rest.IApiClient) { this.client = client; }

    /** Gets week view */
    public async getWeek(req: t.IGetWeekReq): Promise<t.IGetWeekRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/week`;
        return (await this.client.get(url, reqx));
    }

    /** Insert new reservation */
    public async insertReservation(req: t.IInsertReservationReq): Promise<t.IInsertReservationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/new`;
        return (await this.client.post(url, reqx));
    }

    /** Update reservation */
    public async updateReservation(req: t.IUpdateReservationReq): Promise<t.IUpdateReservationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/update/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.put(url, reqx));
    }

    /** Delete reservation */
    public async deleteReservation(req: t.IDeleteReservationReq): Promise<t.IDeleteReservationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/delete/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.delete(url, reqx));
    }

    /** Gets my reservations */
    public async getMyReservations(req: t.IGetMyReservationsReq): Promise<t.IGetMyReservationsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/my`;
        return (await this.client.get(url, reqx));
    }

    /** Gets single reservation */
    public async getSingleReservation(req: t.IGetSingleReservationReq): Promise<t.IGetSingleReservationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx));
    }

    /** Gets my invoices */
    public async getMyInvoices(req: t.IGetMyInvoicesReq): Promise<t.IGetMyInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/invoices/my`;
        return (await this.client.get(url, reqx));
    }

    /** Download invoice */
    public async downloadInvoice(req: t.IDownloadInvoiceReq): Promise<t.IDownloadInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/reservations/invoices/${enc(req.id)}/download`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

}
